import React, { createContext, useCallback, useContext, useState } from "react";

interface DataVersionContextType {
  dataVersion: number;
  incrementDataVersion: () => void;
}

const DataVersionContext = createContext<DataVersionContextType>({
  dataVersion: 0,
  incrementDataVersion: () => {},
});

export function useDataVersion(): DataVersionContextType {
  return useContext(DataVersionContext);
}

export function DataVersionProvider({ children }: { children: React.ReactNode }) {
  const [dataVersion, setDataVersion] = useState(0);
  const incrementDataVersion = useCallback(() => setDataVersion((v) => v + 1), []);
  return (
    <DataVersionContext.Provider value={{ dataVersion, incrementDataVersion }}>
      {children}
    </DataVersionContext.Provider>
  );
}
